"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var __jsx = _react["default"].createElement;
var CategoriesSliderMobile = function CategoriesSliderMobile(props) {
  var categories = props.categories;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      overflowY: "hidden",
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      "::-webkit-scrollbar": {
        display: "none"
      },
      scrollbarWidth: "none"
    }
  }, categories === null || categories === void 0 ? void 0 : categories.map(function (category, index) {
    return __jsx(Link, {
      route: "category-page",
      params: category,
      key: index
    }, __jsx(_LinkRaw["default"], {
      title: category.name,
      sx: {
        display: "flex",
        alignItems: "center",
        height: "36px",
        color: "main",
        marginRight: "s5",
        borderColor: "neutral",
        borderStyle: "solid",
        borderWidth: "1px",
        flex: "0 0 auto",
        font: "xs_caps",
        borderRadius: "5px",
        px: "s6"
      }
    }, category.name));
  }));
};
var _default = CategoriesSliderMobile;
exports["default"] = _default;